import { render, staticRenderFns } from "./CampaignsRejected.vue?vue&type=template&id=ba9d5c66&scoped=true"
import script from "./CampaignsRejected.vue?vue&type=script&lang=js"
export * from "./CampaignsRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9d5c66",
  null
  
)

export default component.exports